import React, { type ReactElement } from 'react';

import { SaviyntRenderQuillDelta } from '../../../../shared/components';
import { type RichTextField } from '../../../../shared/types';

interface RichTextProps {
  field: RichTextField;
}

function RichText({ field }: RichTextProps): ReactElement | null {
  const {
    advConfig: { richText },
  } = field;

  const isEmpty =
    !richText ||
    richText.ops.every((op) => {
      if (typeof op.insert === 'string') {
        return op.insert.trim() === '';
      }

      return false;
    });

  if (isEmpty) {
    return null;
  }

  return <SaviyntRenderQuillDelta delta={richText} confirmExternalLinks />;
}

export default RichText;
